import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, Container } from "reactstrap";

import Ship_Tolaut_Logo from "../../../assets/img/portal/ship_tollaut_logo.svg";
import IMO_Logo from "../../../assets/img/portal/imo.png";
import JAGA_Logo from "../../../assets/img/portal/jaga_logo.png";
import NavbarPortal from "./defaultLayout/NavBarPortal";
import { portalMenuGetList } from "../../../actions/portalAction";
import Footer from "./defaultLayout/Footer";
import adsTemas from "../../../assets/img/iklan-temas.jpg";
import "../Portal/portal.css";

class Portal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ads: true,
      adsZoom: false,
      adsBottom: true,
      showSmallAd: true,
    };
  }

  componentDidMount() {
    this.props.portalMenuGetList();
  }

  RenderContent() {
    return <div>{this.props.children}</div>;
  }

  handleCloseAds() {
    this.setState({ ads: false });
  }

  handleCloseAdsBottom() {
    this.setState({ adsBottom: false });
  }

  handleZoom() {
    this.setState({ adsZoom: true });
  }

  handleZoomOut() {
    this.setState({ adsZoom: false });
  }

  render() {
    return (
      <div
        className={`animated fadeIn portal bg-white ${
          this.state.adsZoom ? "ads-zoomed" : ""
        }`}
      >
        <NavbarPortal props={this.props} />

        <div style={{ marginTop: 62 }}></div>

        {this.props.banner && (
          <div style={{ backgroundColor: "white", position: "relative" }}>
            <div
              style={{
                backgroundColor: "#F5F9FF",
                color: "#224B98",
                fontWeight: 600,
              }}
            >
              <Container>
                <div
                  style={{ display: "flex", justifyContent: "space-evenly" }}
                >
                  <Button
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      backgroundColor: "rgb(28, 71, 218)",
                      color: "white",
                    }}
                    href="/detail/produk"
                    // className="btn btn-danger"
                  >
                    <i
                      className="fa fa-product-hunt"
                      style={{ marginRight: 5 }}
                    />
                    Informasi Produk
                  </Button>
                  <Button
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      backgroundColor: "rgb(28, 71, 218)",
                      color: "white",
                    }}
                    href="/detail/trayek"
                    // className="btn btn-danger"
                  >
                    <i className="fa fa-map-signs" style={{ marginRight: 5 }} />
                    Informasi Trayek
                  </Button>
                  <Button
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      backgroundColor: "rgb(28, 71, 218)",
                      color: "white",
                    }}
                    href="/detail/jadwal-kapal"
                    // className="btn btn-danger"
                  >
                    <i className="fa fa-clock-o" style={{ marginRight: 5 }} />
                    Informasi Jadwal Kapal
                  </Button>
                  <Button
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      backgroundColor: "rgb(28, 71, 218)",
                      color: "white",
                    }}
                    href="/biaya-pengiriman"
                    // className="btn btn-danger"
                  >
                    <i className="fa fa-money" style={{ marginRight: 5 }} />
                    Informasi Biaya Shipper
                  </Button>
                  <Button
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      backgroundColor: "rgb(28, 71, 218)",
                      color: "white",
                    }}
                    href="/simulasi-tarif"
                    // className="btn btn-danger"
                  >
                    <i
                      className="fa fa-calculator"
                      style={{ marginRight: 5 }}
                    />
                    Informasi Simulasi Tarif
                  </Button>
                  <Button
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      backgroundColor: "rgb(28, 71, 218)",
                      color: "white",
                    }}
                    href="/data-users"
                    // className="btn btn-danger"
                  >
                    <i
                      className="fa fa-calculator"
                      style={{ marginRight: 5 }}
                    />
                    Informasi Pelaku Usaha
                  </Button>
                </div>
                <div
                  className="text-right py-3"
                  style={{
                    fontSize: 20,
                    position: "fixed",
                    bottom: 0,
                    right: 0,
                  }}
                >
                  {/* <i className="fa fa-headphones pr-2"></i>  */}
                  <img
                    src={require("../../../assets/img/logo-whatsapp.png")}
                    width={"50px"}
                    style={{ marginBottom: "4px" }}
                  />{" "}
                  Helpdesk :{" "}
                  <a
                    href="https://wa.me/628119698760"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    0811-9698-760
                  </a>
                </div>
              </Container>
            </div>
            <Container className="mt-4">
              <div className="h-100 d-flex align-items-center">
                <div style={{ marginBottom: "90px" }}>
                  <h1
                    style={{
                      color: "#224B98",
                      fontWeight: 800,
                      fontSize: 50,
                      maxWidth: 500,
                    }}
                  >
                    Portal Tol Laut Indonesia
                  </h1>
                  <p
                    style={{
                      color: "#454545",
                      fontSize: 18,
                      maxWidth: 400,
                      margin: "32px 0",
                    }}
                  >
                    Dapatkan semua informasi dan kemudahan mengakses layanan Tol
                    Laut di sini !
                  </p>
                  <div className="d-flex flex-row justify-content-center mb-4">
                    {/* <img src={IMO_Logo} alt="IMO" width="80%"  />
                  <img src={JAGA_Logo} alt="IMO" width="20%" height={'10%'}  /> */}
                    {/* <img src={IMO_Logo} alt="IMO" width="40%" className='mr-4'  /> */}
                    <a
                      target="_blank"
                      href="https://jaga.id/pelabuhan?vnk=9f918da8"
                    >
                      <img
                        src={JAGA_Logo}
                        alt="jaga"
                        width="50%"
                        height="80%"
                      />
                    </a>
                  </div>
                  {/* <Button onClick={() => window.scrollTo(0, 450)} style={{ backgroundColor: '#224B98', color: 'white', fontWeight: 700, padding: '12px 50px', borderRadius: 12, fontSize: 17 }}>Mulai</Button> */}
                </div>
                <img
                  src={Ship_Tolaut_Logo}
                  alt="Illustrasi Kapal Tollaut"
                  width={700}
                  className="d-none d-lg-block"
                />
              </div>
            </Container>
            <div
              className={`ads ${this.state.ads ? "open-ads" : "close-ads"} ${
                this.state.adsZoom && " ads-zoom"
              }`}
            >
              <div className="ads-photo">
                <img src={adsTemas} alt="" />
                <div className="icon-zoom-out">
                  <i
                    className="fa fa-times-circle-o"
                    onClick={() => this.handleZoomOut()}
                  ></i>
                </div>
              </div>
              <i
                className="fa fa-times"
                onClick={() => this.handleCloseAds()}
              ></i>
              <div className="icon-zoom" onClick={() => this.handleZoom()}>
                <i className="fa fa-search-plus"></i>
              </div>
            </div>
          </div>
        )}

        {this.RenderContent()}

        <Footer props={this.props} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  portalGetListPage: state.portals.portalGetListPage,
});

const mapDispatchToProps = (dispatch) => {
  return {
    portalMenuGetList: () => dispatch(portalMenuGetList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Portal);
